import { render, staticRenderFns } from "./VariantStats.vue?vue&type=template&id=7870ccdf&"
import script from "./VariantStats.vue?vue&type=script&lang=js&"
export * from "./VariantStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports